import { Directive, Input, ElementRef } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
  selector: '[decimalMask]',
  standalone: false
})
export class DecimalMaskDirective {
  private integerDigits: number = 6;
  private decimalDigits: number = 2;
  
  @Input('decimalMask') set config(value: string) {
    const parts = value.split(',');
    this.integerDigits = parseInt(parts[0], 10) || 6;
    this.decimalDigits = parseInt(parts[1], 10) || 2;
  }
  
  constructor(
    private el: ElementRef,
    private control: NgControl
  ) {}
  
  ngOnInit() {
    const input = this.el.nativeElement;
    
    input.addEventListener('input', (e: Event) => {
      let value = (e.target as HTMLInputElement).value;
      
      // Remove everything except digits and decimal point
      value = value.replace(/[^\d,]/g, '');
      
      // Split by decimal point
      const parts = value.split(',');
      
      // Handle integer part
      if (parts[0].length > this.integerDigits) {
        parts[0] = parts[0].substring(0, this.integerDigits);
      }
      
      // Handle decimal part
      if (parts.length > 1) {
        if (parts[1].length > this.decimalDigits) {
          parts[1] = parts[1].substring(0, this.decimalDigits);
        }
        // Remove decimal point if no decimal digits allowed
        if (this.decimalDigits === 0) {
          parts.pop();
        }
      }
      
      // Reconstruct value
      let newValue = parts[0];
      if (parts.length > 1 && this.decimalDigits > 0) {
        newValue += ',' + parts[1];
      }
      
      // Update input value
      (e.target as HTMLInputElement).value = newValue;
      
      // Update control value
      if (this.control && this.control.control) {
        this.control.control.setValue(newValue, { emitEvent: false });
      }
    });
  }
}